<div class="splash-page">

  <h1 class="title">ParkingPerks</h1>

  <p class="tagline">
    Helping private lot owners and drivers connect through simple,
    hassle-free parking payments.
  </p>

  <div class="coming-soon-card">
    <h2>🚧 Coming Soon</h2>

    <ul>
      <li>Lot Owner Dashboards</li>
      <li>Lot Metrics & Analytics</li>
      <li>Checkout Page Customization</li>
    </ul>
  </div>

</div>
